import React, {Component} from 'react';
import {CircularProgress} from '@material-ui/core';
import './index.scss';

interface ProgressSpinnerProps {
  className?: string;
}

export default class ProgressSpinner extends Component<ProgressSpinnerProps> {
  render() {
    const fullClassName = this.props.className ? 'progress-spinner ' + this.props.className : 'progress-spinner';
    return <div className={fullClassName}><CircularProgress /></div>;
  }
}